module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e65223c","hasScoped":false}!./src/app/pages/withNavigation/productGroups/productGroups.html
// module id = 3098
// module chunks = 1